export default __webpack_public_path__ + "static/hr-52429edf5f6b22a2a254b96d507a7e25.png";